module.exports = __webpack_public_path__ + "img/parents.5ff7e98d.svg";